__turbopack_context__.v({
  "btnGoAR": "CoinCanvas-module-scss-module__BbhgMW__btnGoAR",
  "coinCanvas": "CoinCanvas-module-scss-module__BbhgMW__coinCanvas",
  "coinCanvasWrapper": "CoinCanvas-module-scss-module__BbhgMW__coinCanvasWrapper",
  "coinEndPanel": "CoinCanvas-module-scss-module__BbhgMW__coinEndPanel",
  "coinEndPanelExpanded": "CoinCanvas-module-scss-module__BbhgMW__coinEndPanelExpanded",
  "coinEndPanelInner": "CoinCanvas-module-scss-module__BbhgMW__coinEndPanelInner",
  "coinEndPanelVisible": "CoinCanvas-module-scss-module__BbhgMW__coinEndPanelVisible",
  "coinItem": "CoinCanvas-module-scss-module__BbhgMW__coinItem",
  "emojiPic": "CoinCanvas-module-scss-module__BbhgMW__emojiPic",
});
